import at from '../actionTypes'
import createReducer from './utilities/createReducer'

export default createReducer({}, {
	[at.APP_SHOW_TOP_BAR]: (state, action) => ({
		...state,
		showTopBar: action.payload.showTopBar
	}),

	[at.APP_MESSAGE]: (state, action) => ({
		...state,
		message: action.payload.message,
		messageType: action.payload.messageType ? action.payload.messageType : false,
		showSnackbar: true
	}),

	[at.APP_HEADING]: (state, action) => ({
		...state,
		heading: action.payload.heading
	}),

	[at.APP_PAGE_LOADED]: (state, action) => ({
		...state,
		pageHasLoaded: action.payload.pageHasLoaded
	}),

	[at.APP_SHOW_BOTTOM_BAR]: (state, action) => ({
		...state,
		showBottomBar: action.payload.showBottomBar
	}),

	[at.APP_SHOW_BOTTOM_NAV_BAR]: (state, action) => ({
		...state,
		showBottomNavBar: action.payload.showBottomNavBar
	}),

	[at.APP_BOTTOM_NAV_BAR_HANDLE_CLICK]: (state, action) => ({
		...state,
		bottomNavBarHandleClick: action.payload.bottomNavBarHandleClick
	}),

	[at.APP_BOTTOM_NAV_BAR_LABEL_NEXT]: (state, action) => ({
		...state,
		bottomNavBarLabelNext: action.payload.bottomNavBarLabelNext
	}),

	[at.APP_NEXT_BUTTON_IS_LOADING]: (state, action) => ({
		...state,
		nextButtonIsLoading: action.payload.nextButtonIsLoading
	}),

	[at.APP_DRAWER_OPEN]: (state, action) => ({
		...state,
		drawerOpen: action.payload.drawerOpen
	}),

	[at.APP_SHOW_SNACKBAR]: (state, action) => ({
		...state,
		showSnackbar: action.payload.showSnackbar
	}),

	[at.APP_BACKGROUND_IMAGE]: (state, action) => ({
		...state,
		backgroundImage: action.payload.backgroundImage
	}),

	[at.APP_BOTTOM_BAR_VALUE]: (state, action) => ({
		...state,
		bottomBarValue: action.payload.bottomBarValue
	}),

	[at.APP_BACK_BUTTON_FUNCTION]: (state, action) => ({
		...state,
		backButtonFunction: action.payload.backButtonFunction
	}),

	[at.appAddContextMenu]: (state, action) => {
		let contextMenus = [...(state.contextMenus ? state.contextMenus : [])]
		const hasMenuAlready = contextMenus.filter(menu => (menu.text === action.payload.text || menu.menuKey === action.payload.menuKey)).length > 0
		if (!hasMenuAlready) {
			contextMenus.push(action.payload)
		} else {
			//	Use the menuKey to overwrite
			contextMenus = contextMenus.map(menu => ((menu.menuKey === action.payload.menuKey) ? action.payload : menu))
		}
		return ({
			...state,
			contextMenus
		})
	}
})



// WEBPACK FOOTER //
// ./src/redux/reducers/appReducer.js